import React from "react";
import logo from "../../asset/landing-lg.png";

const LandingFooter = () => {
  return (
    <footer style={styles.footerContainer}>
      <div style={styles.footerContent}>
        {/* Logo and Description */}
        <div style={styles.section}>
          <div style={styles.logo}>
            <img
              src={logo}
              alt="Logo"
              style={{ width: "80px", height: "80px" }}
            />
          </div>
          <p style={styles.description}>
            Empowering Youth, Connecting Communities
          </p>
          <p style={styles.text}>
            YouthPlus is a vibrant social platform designed to foster community,
            connect individuals, and enable growth. 
            {/* Whether you’re sharing
            moments, creating events, or building your business page, YouthPlus
            has you covered. */}
          </p>
        </div>

        {/* Quick Access */}
        <div style={styles.section}>
          <h4 style={styles.heading}>Quick Access</h4>
          <ul style={styles.linkList}>
            <li><a href="#home" style={styles.linkStyles}>Home</a></li>
            <li><a href="#features" style={styles.linkStyles}>Features</a></li>
            <li><a href="#partners" style={styles.linkStyles}>Partners</a></li>

            {/* <li>Blogs</li>
            <li>About Us</li>
            <li>Contact Us</li>
            <li>FAQs</li> */}
          </ul>
        </div>

        {/* Community */}
        <div style={styles.section}>
          <h4 style={styles.heading}>Community</h4>
          <ul style={styles.linkList}>
            <li><a href="https://www.youthplus.ng/blogs" target="blank" style={styles.linkStyles}>Blogs</a></li>
            <li><a href="https://www.youthplus.ng/events/" target="blank" style={styles.linkStyles}>Events</a></li>
            <li><a href="https://www.youthplus.ng/groups" target="blank" style={styles.linkStyles}>Groups</a></li>
            <li><a href="https://www.youthplus.ng/pages" target="blank" style={styles.linkStyles}>Pages</a></li>
            <li><a href="https://www.youthplus.ng/forum/" target="blank" style={styles.linkStyles}>Forums</a></li>
            <li><a href="https://www.youthplus.ng/products" target="blank" style={styles.linkStyles}>Marketplace</a></li>
          </ul>
        </div>

        {/* Stay Connected */}
        {/* <div style={styles.section}>
          <h4 style={styles.heading}>Stay Connected</h4>
          <p>Subscribe to our newsletter for updates and tips.</p>
          <input type="email" placeholder="Enter email" style={styles.input} />
          <button style={styles.button}>Subscribe</button>
        </div> */}
      </div>

      <div style={styles.bottom}>
        <p style={styles.copyText}>© 2024 YouthPlus. All Rights Reserved.</p>
        <div style={styles.policyLinks}>
          <a href="/policy" target="blank" style={styles.linkStyles}>Privacy Policy</a> | <a href="/terms" target="blank" style={styles.linkStyles}>Terms of Use</a>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footerContainer: {
    backgroundColor: "#09839B",
    color: "#fff",
    padding: "40px 20px",
    // marginTop:"-12rem"
  },
  footerContent: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    maxWidth: "100%",
    margin: "0 auto",
    // border:'2px solid red'
  },
  section: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    margin: "10px",
    minWidth: "200px",
    justifyContent:'center',
    // border:'2px solid red'
    
  },
  logo: {
    marginBottom: "15px",
  },
  description: {
    fontWeight: "bold",
    fontSize: "1.2em",
  },
  text: {
    marginTop: "10px",
  },
  heading: {
    fontSize: "1.1em",
    marginBottom: "10px",
    fontWeight: "bold",
  },
  linkList: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
    lineHeight: "1.8",
  },
  linkStyles: {
    color: '#fff',
    textDecoration: 'none'
  },
  input: {
    padding: "8px",
    margin: "10px 0",
    width: "100%",
    borderRadius: "4px",
    border: "none",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#007E9E",
    color: "#fff",
    border: "1px solid #fff",
    borderRadius: "4px",
    cursor: "pointer",
  },
  bottom: {
    borderTop: "1px solid rgba(255, 255, 255, 0.2)",
    marginTop: "20px",
    paddingTop: "20px",
    textAlign: "center",
  },
  copyText: {
    fontSize: "0.9em",
  },
  policyLinks: {
    marginTop: "10px",
  },
};

export default LandingFooter;
